import {RouteContext} from "../../../RouteContext";
import {InputStringStatePair, StatePair, useError, useInputString, useStatePair} from "../../../../type/States";
import React from "react";
import {Button, Field, FieldProps, Input} from "@fluentui/react-components";
import {Styles} from "../../common/Styles";
import {DataTransferObjectValidation} from "../../../../type/Types";
import {Column, Row} from "../../common/Layout";
import {
    ShoppingMainKeywordDataTransferObject
} from "../../../../model/dto/content/ShoppingMainKeywordDataTransterObject";

export default function ExposedAt(props: RouteContext) {
    const styles = Styles.useEditorStyles()
    const postErrorState = useError()

    const inputStates: Record<keyof ShoppingMainKeywordDataTransferObject.PostByExposedAt, InputStringStatePair> = {
        exposedAt:useInputString(''),
    }
    const inputValidationStates: Record<keyof ShoppingMainKeywordDataTransferObject.PostByExposedAt, StatePair<FieldProps['validationState']>> = {
        exposedAt: useStatePair<FieldProps['validationState']>('none'),
    }
    const patchMainKeywordErrorState = useError()

    const onDoneClick = () => {
        inputValidationStates.exposedAt.setValue('none')
        try {
            const dto: ShoppingMainKeywordDataTransferObject.PostByExposedAt = {
                exposedAt: DataTransferObjectValidation.validate(ShoppingMainKeywordDataTransferObject.PostByExposedAt.validation, 'exposedAt', inputStates.exposedAt.value, () => inputValidationStates.exposedAt.setValue('error')),
            }

            console.log(dto)

            fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/mainKeywords/${dto.exposedAt}`,
                {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(dto),
                },
            )
                .then(async value => {
                    const res = await value.json()
                    console.log(res)

                    if (!res) {
                        throw new Error('메인키워드 다수 생성 실패')
                    }

                    window.alert('추가되었습니다.')

                }).catch(postErrorState.setValue)
        } catch (error) {
            console.error(error)
        }
    }

    return <>
        <patchMainKeywordErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Field
                className={styles.field}
                label={"노출 일자"}
                validationState={inputValidationStates.exposedAt.value}>
                <Input
                    value={inputStates.exposedAt.value}
                    onChange={inputStates.exposedAt.onChange} />
            </Field>
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </Row>
        </Column>
    </>
}